//
//  default-routes.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { RouteConfig } from 'vue-router';

const defaultRoutes: RouteConfig[] = [

    {
        path: '/*',
        redirect: '/fr',
    },

];

export default defaultRoutes;
